import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/company";
import Brand from "@/components/Brand";

export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="legal-footer" className="border-t border-border bg-card">
      <div className="mx-auto max-w-6xl px-6 py-8">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
          <Brand />
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-muted-foreground transition-colors hover:text-primary">
              Privacy Policy
            </Link>
            <Link to="/terms" data-testid="footer-terms-link" className="text-muted-foreground transition-colors hover:text-primary">
              Terms of Service
            </Link>
            <a href={`mailto:${COMPANY.contactEmail}`} className="text-muted-foreground transition-colors hover:text-primary">
              Contact
            </a>
          </nav>
        </div>
        <div className="mt-6 border-t border-border pt-5 text-sm leading-relaxed text-muted-foreground">
          <p data-testid="footer-legal-ownership">{COMPANY.ownershipStatement}</p>
          <p className="mt-2">
            © {year} <span data-testid="footer-legal-name" className="font-medium text-foreground">{COMPANY.legalName}</span>.
            All rights reserved. {COMPANY.brand} is the customer-facing brand of {COMPANY.legalName}.
          </p>
        </div>
      </div>
    </footer>
  );
}
